import clsx from 'clsx';
import React, {
  Dispatch,
  KeyboardEvent as ReactKeyboardEvent,
  SetStateAction,
  use,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';

import { AppContext } from '../contexts/app.context';

import styles from './Nav.module.scss';

import 'bootstrap-icons/font/bootstrap-icons.min.css';

const SEASONS = ['Spring', 'Summer', 'Autumn', 'Winter'];

const NAVS = [
  { label: 'About', icon: 'bi-info-square' },
  { label: 'Resume', icon: 'bi-card-heading' },
  { label: 'Contact', icon: 'bi-envelope' },
];

// const getSeason = () => {
//   let dt: Date | string = new Date();
//   let mm = dt.getMonth() + 1;
//   let dd = dt.getDate();
//   dt =
//     (mm < 10 ? '0' + mm : mm.toString()) + (dd < 10 ? '0' + dd : dd.toString());
//   if (dt > '1220' || dt < '0321') return 'winter';
//   if (dt > '0320' && dt < '0621') return 'spring';
//   if (dt > '0620' && dt < '0921') return 'summer';
//   return 'autumn';
// };

interface NavParams {
  contentSelection: string | undefined;
  setContentSelection: Dispatch<SetStateAction<string | undefined>>;
}

const Nav = ({ contentSelection, setContentSelection }: NavParams) => {
  const location = useLocation();
  const [showSeasonSelect, setShowSeasonSelect] = useState(false);
  const navigate = useNavigate();

  const { season, assignSeason } = use(AppContext);

  const seasonRef = useRef<HTMLSelectElement | null>(null);
  const timerRef = useRef<{ id: null | NodeJS.Timer; clickCount: number }>({
    id: null,
    clickCount: 0,
  });

  const clickListener = () => {
    if (!timerRef.current.id) {
      timerRef.current.id = setInterval(() => {
        clearInterval(timerRef.current.id as NodeJS.Timer);
        timerRef.current = { id: null, clickCount: 0 };
      }, 1500);
    }
    timerRef.current.clickCount += 1;
    if (timerRef.current.clickCount === 3) {
      setShowSeasonSelect(!showSeasonSelect);
    }
  };

  const keyListener = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.shiftKey && e.code === 'KeyS') {
      setShowSeasonSelect(!showSeasonSelect);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyListener);
    return () => {
      document.removeEventListener('keydown', keyListener);
    };
  });

  useEffect(() => {
    const match = matchPath('/:content', location.pathname);
    if (
      match &&
      NAVS.some((nav) => nav.label.toLowerCase() === match.params.content)
    ) {
      setContentSelection(match.params.content);
    } else {
      setContentSelection(undefined);
    }
  }, [location, setContentSelection]);

  useEffect(() => {
    if (!showSeasonSelect) return;
    seasonRef.current?.focus();
  }, [showSeasonSelect]);

  const changeSeason = (e: React.ChangeEvent<HTMLSelectElement>) => {
    assignSeason(e.target.value);
  };

  return (
    <div
      id="main-nav"
      className={clsx(
        styles['main-nav'],
        contentSelection && styles['nav-overlay-min'],
        !contentSelection && styles['nav-overlay'],
        season,
      )}
    >
      <nav>
        <div className={clsx('letter-spaced', styles['site-name'])}>
          <Link
            to="/"
            onClick={() => setContentSelection(undefined)}
            onKeyDown={(e: ReactKeyboardEvent) => {
              if (e.key === ' ') setContentSelection(undefined);
            }}
          >
            otherblandart.com
          </Link>
        </div>
        <ul>
          {NAVS.map((item, idx) => (
            <li
              key={item.label}
              id={item.label.toLowerCase()}
              className={clsx(
                styles['main-nav-item'],
                styles[`nav-link-${idx + 1}`],
                item.label.toLowerCase() === contentSelection &&
                  styles['nav-selected'],
              )}
              title={item.label}
            >
              <Link
                className={styles['nav-link']}
                to={`/${item.label.toLowerCase()}`}
                onKeyDown={(e: ReactKeyboardEvent) => {
                  if (e.key === ' ') navigate(`/${item.label.toLowerCase()}`);
                }}
              >
                <i className={item.icon} aria-label={item.label} />
                <span className="sm-hidden">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <button
        type="button"
        className={styles['close-page']}
        aria-label="Close Page"
        onClick={() => {
          setContentSelection(undefined);
          navigate('/');
        }}
      >
        <i className="bi-caret-up"></i>
      </button>
      {showSeasonSelect && (
        <select
          id="ChangeSeason"
          onChange={changeSeason}
          ref={seasonRef}
          value={season}
        >
          {SEASONS.map((sn) => (
            <option value={sn.toLowerCase()} key={sn}>
              {sn}
            </option>
          ))}
        </select>
      )}
      <div className={styles['copy-credit']} onClick={clickListener}>
        &copy;2020&nbsp;&ndash;&nbsp;
        {new Date().getFullYear()}&nbsp;
        otherblandart.com&nbsp;&nbsp;|&nbsp;&nbsp;Built using Bootstrap & React
      </div>
    </div>
  );
};

export default Nav;
